import * as __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__ from "react/jsx-runtime";
import "react";
import * as __WEBPACK_EXTERNAL_MODULE_class_variance_authority_159ad65c__ from "class-variance-authority";
import * as __WEBPACK_EXTERNAL_MODULE__lib_SIcon_mjs_c59156f3__ from "../lib/SIcon.mjs";
import * as __WEBPACK_EXTERNAL_MODULE__lib_utils_mjs_6a3f3df3__ from "../lib/utils.mjs";
const alertVariants = (0, __WEBPACK_EXTERNAL_MODULE_class_variance_authority_159ad65c__.cva)("relative w-full rounded-[12px] border px-4 py-3 text-sm grid has-[>svg]:grid-cols-[calc(var(--spacing)*4)_1fr] grid-cols-[0_1fr] has-[>svg]:gap-x-3 gap-y-0.5 items-start [&>svg]:size-4 [&>svg]:translate-y-0.5 [&>svg]:text-current", {
    variants: {
        variant: {
            default: "bg-grayscale-darker text-foreground",
            primary: "text-brand-primary bg-brand-primary/10 border-brand-primary/20 [&>svg]:text-current *:data-[slot=alert-description]:text-brand-primary/90",
            destructive: "text-alert-primary bg-alert-background/40 border-alert-background [&>svg]:text-current *:data-[slot=alert-description]:text-alert-primary/90"
        }
    },
    defaultVariants: {
        variant: "default"
    }
});
function Alert({ className, variant, icon, iconClassName, ...props }) {
    return /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsxs)("div", {
        "data-slot": "alert",
        role: "alert",
        className: (0, __WEBPACK_EXTERNAL_MODULE__lib_utils_mjs_6a3f3df3__.cn)(alertVariants({
            variant
        }), className),
        ...props,
        children: [
            icon ? /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)(__WEBPACK_EXTERNAL_MODULE__lib_SIcon_mjs_c59156f3__.SIcon, {
                type: icon,
                className: (0, __WEBPACK_EXTERNAL_MODULE__lib_utils_mjs_6a3f3df3__.cn)("opacity-50", iconClassName)
            }) : null,
            props.children
        ]
    });
}
function AlertTitle({ className, ...props }) {
    return /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)("div", {
        "data-slot": "alert-title",
        className: (0, __WEBPACK_EXTERNAL_MODULE__lib_utils_mjs_6a3f3df3__.cn)("col-start-2 line-clamp-1 min-h-4 font-medium tracking-tight", className),
        ...props
    });
}
function AlertDescription({ className, ...props }) {
    return /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)("div", {
        "data-slot": "alert-description",
        className: (0, __WEBPACK_EXTERNAL_MODULE__lib_utils_mjs_6a3f3df3__.cn)("text-secondary-foreground col-start-2 grid justify-items-start gap-1 text-sm [&_p]:leading-relaxed", className),
        ...props
    });
}
export { Alert, AlertDescription, AlertTitle };
